import React from 'react';
import _ from 'lodash';

import {
  BaseWidget,
  routeDirectory
} from 'modules';
import {
  Box,
  Button,
  styled
} from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { Table } from 'iron-forge-react-modules';
import { SalesChannelName } from 'generated/graphql';
import * as types from './types';
import * as dataService from './dataService';



const ButtonBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1)
}));

const TableComponent = Table.genTableComponent<types.IColumnId>();

export interface IProps {
  salesChannel: SalesChannelName;
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery(props.salesChannel);
  const navigate = useNavigate();



  function handleClickReconciliationReport() {
    navigate(routeDirectory.admin.orders.path(props.salesChannel, 'awaitingApproval'));
  }

  function handleClickGoTo3pl() {
    navigate(routeDirectory.admin.orders.path(props.salesChannel, 'awaitingApproval'));
  }

  function handleClickImport() {
    navigate(routeDirectory.admin.thirdPartyLogistics.path());
  }



  const rows = React.useMemo(
    () => _.map(tuple.data.orders, (order): types.IRow => ({
      id: order.id,
      columnId2Value: {
        orderDate: {
          type: 'string',
          label: order.orderDate.toFormat('yyyy-MM-dd @ hh:mm a')
        },
        orderNumber: {
          type: 'string',
          label: order.orderNumber
        }
      }
    })),
    [tuple.data.orders]
  );

  const orderType = props.salesChannel === 'ecommerce' ? "E-Comm" : "3PL";

  return (
    <BaseWidget.FC
      title={`Recent ${orderType} Orders`}
      elAction={(
        <ButtonBox>
          <Button
            variant="contained"
            onClick={props.salesChannel === 'ecommerce' ? handleClickReconciliationReport : handleClickGoTo3pl}>
            View Orders
          </Button>

          {props.salesChannel === 'thirdPartyLogistics' && (
            <Button onClick={handleClickImport}>
              Import
            </Button>
          )}
        </ButtonBox>
      )}>
      <TableComponent
        rows={rows}
        disableSorting
        initSortOptions={{
          columnId: 'orderDate',
          direction: 'descending'
        }}
        columns={[
          {
            id: 'orderNumber',
            label: "Order Number"
          },
          {
            id: 'orderDate',
            label: "Order Date"
          }
        ]}
      />
    </BaseWidget.FC>
  );
};
